import { pluck, tap } from 'rxjs/operators'
import { defineComponent, PropType } from 'vue'

import { Container, ContainerStatus } from '@skinsoft/types'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { LocalizedString } from '@skinsoft/ui'
import { ContainerFeaturedCard } from '../../container-featured-card'
import { DELETE_CARD } from '@skinsoft/events'

const PAGE_SIZE = 20

export const ContainerSublistStatus = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sLocalizedString: LocalizedString,
        sContainerFeaturedCard: ContainerFeaturedCard,
    },
    props: {
        statuses: {
            type: Array as PropType<ContainerStatus[]>,
            default: () => [],
        },
        title: String,
        emptyMessage: String,
        query: { type: String, required: true },
    },
    template: require('./container-sublist-status.html'),
    data() {
        return {
            containers: [] as Container[],
            canSeeMore: false,
            DELETE_CARD,
        }
    },
    mounted() {
        this.subscribeToContainerList()
    },
    computed: {
        nextPage(): number {
            return Math.floor(this.containers.length / PAGE_SIZE)
        },
    },
    methods: {
        subscribeToContainerList(nextPage: number = 0) {
            this.subscribeTo(
                this.$containerDataStore
                    .searchAmongStatusList(
                        this.query,
                        PAGE_SIZE,
                        nextPage,
                        this.statuses,
                        { entityFields: ['6024e2dcecfca62afd28daad'], sortAsc: false },
                    )
                    .pipe(
                        tap(
                            (searchResponse) =>
                                (this.canSeeMore =
                                    searchResponse.totalSize >
                                    this.containers.length + searchResponse.allData?.length),
                        ),
                        pluck('allData'),
                    ),
                (containers) => {
                    this.containers = this.containers.concat(containers)
                },
                'containers',
            )
        },

        loadNext() {
            this.unsubscribeFrom('containers')
            this.subscribeToContainerList(this.nextPage)
        },

        onContainerDeleted(containerId: string) {
            this.$containerDataStore.delete(containerId).subscribe(() => {
                this.containers = []
                this.unsubscribeFrom('containers')
                this.subscribeToContainerList()
            })
        },
    },
    watch: {
        query() {
            this.unsubscribeFrom('containers')
            this.containers = []
            this.subscribeToContainerList()
        },
    },
})
